import React, { useState } from "react";
import styled from "styled-components";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useRBAC } from "../context/rbac/RBACContext";
import { DashboardModules } from "../config/app.config";

const Layout = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
`;

const Content = styled.div`
	position: relative;
	width: 100%;
	overflow-y: auto;
	height: 100%;
`;

const Div = styled.div`
	position: relative;
	display: flex;
	height: 100%;
	width: 100%;
	overflow-x: hidden;
`;

const OffersLayout = (props) => {
	const [showSidebar, toggle] = useState(true);
	const { allowedSidebarLinksPerModule } = useRBAC();
	const allowedSidebarLinks = allowedSidebarLinksPerModule[DashboardModules.OFFERS];

	return (
		<Layout>
			<Header title={"Offers"} machinePage={false} showSidebar={showSidebar} toggle={toggle} />
			<Div>
				<Sidebar config={allowedSidebarLinks} showSidebar={showSidebar} toggle={toggle} />
				<Content>{props.children}</Content>
			</Div>
		</Layout>
	);
};

export default OffersLayout;
